<template>
  <div class="users-and-groups-wrapper card">
    <page-header
      title="Edit User"
      breadcrumbText="Dashboard >> Settings >> Users and Groups >> Edit User"
    />
    <edit-user-form />
  </div>
</template>

<script>
import EditUserForm from "./partials/EditUserForm";
export default {
  components: {
    EditUserForm,
  },
};
</script>

<style scoped></style>
